export class ClaimsDocumentsConfiguration {
  url: string;
}
